import { $themeConfig } from '@themeConfig'

function safe(obj, path, defaultValue) {
  return path.reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj) ?? defaultValue
}

export default {
  namespaced: true,
  state: {
    layout: {
      isRTL: safe($themeConfig, ['layout', 'isRTL'], false),
      skin: localStorage.getItem('vuexy-skin') || safe($themeConfig, ['layout', 'skin'], 'light'),
      routerTransition: safe($themeConfig, ['layout', 'routerTransition'], 'zoom-fade'),
      type: safe($themeConfig, ['layout', 'type'], 'vertical'),
      contentWidth: safe($themeConfig, ['layout', 'contentWidth'], 'full'),
      menu: {
        hidden: safe($themeConfig, ['layout', 'menu', 'hidden'], false),
      },
      navbar: {
        type: safe($themeConfig, ['layout', 'navbar', 'type'], 'floating'),
        backgroundColor: safe($themeConfig, ['layout', 'navbar', 'backgroundColor'], ''),
      },
      footer: {
        type: safe($themeConfig, ['layout', 'footer', 'type'], 'static'),
      },
    },
  },
  getters: {},
  mutations: {
    TOGGLE_RTL(state) {
      state.layout.isRTL = !state.layout.isRTL
      document.documentElement.setAttribute('dir', state.layout.isRTL ? 'rtl' : 'ltr')
    },
    UPDATE_SKIN(state, skin) {
      state.layout.skin = skin

      // Update value in localStorage
      localStorage.setItem('vuexy-skin', skin)

      // Update DOM for dark-layout
      if (skin === 'dark') document.body.classList.add('dark-layout')
      else if (document.body.className.match('dark-layout')) document.body.classList.remove('dark-layout')
    },
    UPDATE_ROUTER_TRANSITION(state, val) {
      state.layout.routerTransition = val
    },
    UPDATE_LAYOUT_TYPE(state, val) {
      state.layout.type = val
    },
    UPDATE_CONTENT_WIDTH(state, val) {
      state.layout.contentWidth = val
    },
    UPDATE_NAV_MENU_HIDDEN(state, val) {
      state.layout.menu.hidden = val
    },
    UPDATE_NAVBAR_CONFIG(state, obj) {
      Object.assign(state.layout.navbar, obj)
    },
    UPDATE_FOOTER_CONFIG(state, obj) {
      Object.assign(state.layout.footer, obj)
    },
  },
  actions: {},
}
